
const images = require.context('@/assets/circuiti', false, /\.(png|jpe?g|webp|avif)$/);

const imageMap = {
    'monza': 'Autodromo Nazionale di Monza.png',
    'rodriguez': 'Autódromo Hermanos Rodríguez.jpg',
    'interlagos': 'Autódromo José Carlos Pace.jpg',
    'bahrain': 'Bahrain International Circuit.jpg',
    'baku': 'Baku City Circuit.avif',
    'zandvoort': 'Circuit Park Zandvoort.jpg',
    'catalunya': 'Spanish Grand Prix.jpg',
    'monaco': 'Circuit de Monaco.jpg',
    'spa': 'Circuit de Spa-Francorchamps.webp',
    'americas': 'Circuit of the Americas.jpg',
    'hungaroring': 'Hungaroring.jpg',
    'las_vegas': 'Las Vegas Grand Prix.jpg',
    'vegas': 'Las Vegas Grand Prix.jpg',
    'losail': 'Losail International Circuit.jpeg',
    'marina_bay': 'Marina Bay Street Circuit.jpg',
    'miami': 'Miami International Autodrome.avif',
    'red_bull_ring': 'Red Bull Ring Austria.webp',
    'shanghai': 'Shanghai International Circuit.webp',
    'silverstone': 'Silverstone Circuit.jpg',
    'suzuka': 'Suzuka Circuit Japan.webp',
    'yas_marina': 'Yas Marina Circuit.avif',
    'albert_park': 'albert-park-gp-circuit-1.jpg',
    'villeneuve': 'circuit-gilles-villeneuve.jpg',
    'imola': 'imola-circuit-map.jpg', // Assuming you might have this, or need a fallback
    'jeddah': 'Bahrain International Circuit.jpg', // Placeholder since file is missing
    'madrid': 'Spanish Grand Prix.jpg',
    'madring': 'Spanish Grand Prix.jpg',
};

// Fallback logic for files I saw in the list but might have slightly different keys
// The user has:
// "circuito-bahrain-f1-1.jpeg" -> maybe alternate? I'll stick to 'Bahrain International Circuit.jpg'
// "madrid-circuit-map.jpg" -> Future race?

export const getCircuitImage = (circuitId) => {
    if (!circuitId) return null;

    const filename = imageMap[circuitId];
    if (filename) {
        try {
            return images(`./${filename}`);
        } catch (e) {
            console.warn(`Image not found for ${filename} (ID: ${circuitId})`, e);
            return null;
        }
    } else {
        console.warn(`No image mapping found for circuit ID: ${circuitId}`);
    }

    // Try to find a partial match if exact match fails
    // or return a default
    return null;
};

// Load circuit layout images (maps) from assets/tracks
const trackLayouts = require.context('@/assets/tracks', false, /\.(png|jpe?g|webp|avif)$/);

export const getCircuitLayout = (circuitId) => {
    if (!circuitId) return null;

    // Try to find the image matching circuitId with any supported extension
    const fileNames = trackLayouts.keys(); // e.g., ["./monza.png", "./baku.png"]

    // Look for exact match on filename part
    const match = fileNames.find(path => {
        const name = path.replace('./', '').split('.')[0];
        return name === circuitId;
    });

    if (match) {
        return trackLayouts(match);
    }

    return null;
};
